import { Input } from "antd";
import React from "react";

export default function FormOptionInput({
	title,
	placeholder,
	value,
	disabled,
	min,
	max,
	onChange,
	onBlur,
	errors,
	touched,
	name,
	id,
	defaultValue,
}) {
	return (
		<div className="task-option-item">
			<label htmlFor={id} className="form-label">
				{title}
			</label>
			<div className="d-block">
				<Input
					type="text"
					name={name}
					placeholder={placeholder}
					value={value}
					id={id}
					onChange={onChange}
					onBlur={onBlur}
					disabled={disabled}
					min={min}
					max={max}
				/>
				{touched && errors && (
					<div className="text-danger" style={{ marginTop: 4, fontSize: 12 }}>
						{errors}
					</div>
				)}
			</div>
		</div>
	);
}
